import axios from '@/utils/axios'

export const getCommentList = (payload) => {
  return axios.get('/comment', {
    params: payload
  })
}

export const createComment = (data) => {
    return axios.post(`/comment`, data)
}

// export const getCommentSimpleList = (payload) => {
//     return axios.get('/comment_simple_list', {
//         params: payload
//     })
// }

// export const getUserCommentRolesCount = (payload) => {
//     return axios.get('/user_comment_roles_count', {
//         params: payload
//     })
// }

// export const getCommentById = (id) => {
//     return axios.get(`/comment/${id}`);
// }

// export const updateComment = (id, data) => {
//     return axios.put(`/comment/${id}`, data);
// }

// export const updateManyComment = (data) => {
//     return axios.put(`/many_comment`, data);
// }

// export const deleteComment = (id) => {
//     return axios.delete(`/comment/${id}`)
// }